// extracted by mini-css-extract-plugin
export default {"wrap":"LoadingWave_wrap__gACnN","bar":"LoadingWave_bar__7JUJs","loadingWave":"LoadingWave_loadingWave__SQoCn"};